import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import {
    OrangeCard,
    PurpleCard,
    GreenCard,
    BlueCard,
    BlackCard
} from "./components/assets";
import { HeroCard } from "./components/hero-card";
import { HeroContextProvider } from "./util/hero-context";

import { JswProductModalCarousel } from ".";

const heroCardText = [
    {
        eyebrow: "product & issue tracking",
        title: "Software Development",
        image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardSoftwareDev.webp",
        BackgroundImage: OrangeCard,
        label: "software-development"
    },
    {
        eyebrow: "plan and launch campaigns",
        title: "Marketing",
        image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardMarketing.webp",
        BackgroundImage: PurpleCard,
        label: "marketing"
    },
    {
        eyebrow: "manage and track requests",
        title: "IT",
        image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardIt.webp",
        BackgroundImage: GreenCard,
        label: "it"
    },
    {
        eyebrow: "build creative workflows",
        title: "Design",
        image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardDesign.webp",
        BackgroundImage: BlueCard,
        label: "design"
    },
    {
        eyebrow: "create custom processes",
        title: "Operations",
        image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardOps.webp",
        BackgroundImage: BlackCard,
        label: "operations"
    }
];

const heroCardsStyling = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "fit-content",
    gap: "16px",
    overflowX: "auto",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    padding: "64px 10px 10px 10px",
    scrollbarColor: "#AEAEAE rgba(0,0,0,0)",
    [media.below.lg]: {
        paddingBlockStart: "54px",
        justifyContent: "flex-start",
        paddingBlockEnd: "10px",
        marginBlockStart: "3px",
        overflowX: "scroll",
        scrollPaddingTop: "3px"
    }
});

export const HeroCards = () => {
    return (
        <HeroContextProvider>
            <div css={heroCardsStyling}>
                {heroCardText.map((card, index) => (
                    <HeroCard
                        key={index}
                        eyebrow={card.eyebrow}
                        title={card.title}
                        image={card.image}
                        BackgroundImage={card.BackgroundImage}
                        idx={index}
                        label={card.label}
                    />
                ))}
                <JswProductModalCarousel />
            </div>
        </HeroContextProvider>
    );
};
